import { render, staticRenderFns } from "./check.vue?vue&type=template&id=145ce862&scoped=true&"
import script from "./check.vue?vue&type=script&lang=ts&"
export * from "./check.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145ce862",
  null
  
)

export default component.exports